
import React from "react";

const pilares = [
    {
        numero: "01",
        titulo: "Audacia",
        descripcion:
            "Vamos más allá de lo convencional, cuestionamos paradigmas y exploramos nuevas posibilidades.",
    },
    {
        numero: "02",
        titulo: "Innovación",
        descripcion:
            "Desarrollamos propuestas tecnológicas de alto impacto para responder a los desafíos de nuestro entorno.",
    },
    {
        numero: "03",
        titulo: "Transformación",
        descripcion:
            "Convertimos conocimiento, creatividad y estrategia en soluciones con resultados reales.",
    },
];

function PilaresEmpresa() {
    return (
        <div className="empresa-pilares">
            {pilares.map((pilar) => (
                <article
                    className="empresa-pilar"
                    key={pilar.numero}
                >
          <span className="empresa-pilar-number">
            {pilar.numero}
          </span>

                    <h3>{pilar.titulo}</h3>

                    <p>{pilar.descripcion}</p>

                    <span
                        className="empresa-pilar-line"
                        aria-hidden="true"
                    />
                </article>
            ))}
        </div>
    );
}

export default PilaresEmpresa;
